module.exports = __webpack_public_path__ + "static/media/IMG_8038.0e81cbf7.jpg";